// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.box[data-v-2045f80c] {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    /* min-width: 1270px; */\n    height: calc(100%);\n    overflow-y:scroll;\n    overflow-x:scroll;\n    background-color: #FFFFFF;\n}\n.CeilingType[data-v-2045f80c] {\n    position: sticky;\n    top:0;\n    z-index: 9\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
